import { lazy } from 'react';

import { withSuspense } from '@/shared/lib/hocs/with-suspense.hoc';

export const PasswordResetPage = withSuspense(lazy(() => import('./password-reset-page.component')));
